import React from "react";
import Translate, { Message } from "../messages/GeralMessages";

export const GenderType = [
  { name: "Masculino", value: 0 },
  { name: "Feminino", value: 1 }
];

export const GenderTypeObj = [];

export const UserType = [
  { value: 0, name: Translate(Message.PhysicalPerson) },
  { value: 1, name: Translate(Message.LegalPerson) }
];

export const UserTypeObj = {
  Person: 0,
  LegalPerson: 1,
};

export function TypeTranslate(i) {
  const res = UserType.filter(x => x.value == i);
  if (res.length == 0) {
    return "S.I.";
  }
  return res[0].name;
}

export const UserStatusObj = {
  Active: 0,
  Blocked: 1,
  Pending: 2
}

export const UserStatusList = [
  { name: "Ativo", value: 0, color: "info" },
  { name: "Bloqueado", value: 1, color: "danger" },
  { name: "Pendente", value: 2, color: "primary" }
]

export function UserStatusTranslate(i) {
  const res = UserStatusList.filter(x => x.value == i);
  if (res.length > 0) {
    return <span className={`badge badge-${res[0].color}`}>{res[0].name}</span>
  } else {
    return "S.I.";
  }
}

export function ValidaCNPJ(cnpj) {
  var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  var c = String(cnpj).replace(/[^\d]/g, "");

  if (c.length !== 14) return false;

  if (/0{14}/.test(c)) return false;

  for (var i = 0, n = 0; i < 12; n += c[i] * b[++i]);
  if (c[12] != ((n %= 11) < 2 ? 0 : 11 - n)) return false;

  for (var i = 0, n = 0; i <= 12; n += c[i] * b[i++]);
  if (c[13] != ((n %= 11) < 2 ? 0 : 11 - n)) return false;

  return true;
}

export function CPFValidator(strCPF) {
  var Soma;
  var Resto;
  Soma = 0;
  if (strCPF == "00000000000") return false;

  for (let i = 1; i <= 9; i++)
    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
  Resto = (Soma * 10) % 11;

  if (Resto == 10 || Resto == 11) Resto = 0;
  if (Resto != parseInt(strCPF.substring(9, 10))) return false;

  Soma = 0;
  for (let i = 1; i <= 10; i++)
    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
  Resto = (Soma * 10) % 11;

  if (Resto == 10 || Resto == 11) Resto = 0;
  if (Resto != parseInt(strCPF.substring(10, 11))) return false;
  return true;
}

export function PasswordIsStrong(password) {
  let senha = password;
  let forca = 0;
  if (senha.length >= 4 && senha.length <= 7) {
    forca += 10;
  } else if (senha.length > 7) {
    forca += 25;
  }
  if (senha.match(/[a-z]+/)) {
    forca += 10;
  }
  if (senha.match(/[A-Z]+/)) {
    forca += 20;
  }
  if (senha.match(/d+/)) {
    forca += 20;
  }
  if (senha.match(/W+/)) {
    forca += 25;
  }

  if (forca < 30 || forca === 35) {
    return false;
  } else if (forca > 35 && forca < 60) {
    return true;
  } else if (forca >= 60 && forca < 85) {
    return true;
  } else {
    return true;
  }
}


export function CPFMask(cpf) {
  const number = cpf;
  const ddi = number.slice(0, 3);
  const ddd = number.slice(3, 6);
  const cel1 = number.slice(6, 9);
  const cel2 = number.slice(9, 11);

  const organized = `${ddi}.${ddd}.${cel1}-${cel2}`;
  return organized;
}

export function CNPJMask(cpf) {
  let x = cpf.replace(/\D/g, '').match(/(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/);
  const res = !x[2] ? x[1] : x[1] + '.' + x[2] + '.' + x[3] + '/' + x[4] + (x[5] ? '-' + x[5] : '');

  return res;
}

export function CheckUserData(user) {
  let message = "Faltou preencher: ";
  let error = false;
  if (!user.firstName || user.firstName === "") {
    message += " Nome;";
    error = true;
  }
  if (!user.lastName || user.lastName === "") {
    message += " Sobrenome;";
    error = true;
  }
  if (!user.phone || user.phone === "") {
    message += " Celular;";
    error = true;
  }
  if (user.type == UserTypeObj.Person) {
    if (!user.document || user.document === "") {
      message += " CPF;";
      error = true;
    }
  } else if (user.type == UserTypeObj.LegalPerson) {
    if (!user.document || user.document === "") {
      message += " CNPJ;";
      error = true;
    }
  }
  if (!user.email || user.email === "") {
    message += " Email;";
    error = true;
  }

  return { error, message };
}
